import { paths } from "../api-sdk/v3/openapi-spec";

export type TCartApi =
  paths["/chain/findEligibleNonprofitsForCart"]["post"]["requestBody"]["content"]["application/json"]["cart"];

// Same as type from API but with non-optional fields, so we can use where Shopify guarantees values
export type TCart = TCartApi & {
  content: {
    items: Record<string, any>[];
    discounts?: Record<string, any>[] | undefined | null;
  };
};

export type TCartItems = TCart["content"]["items"];

export type TCartDiscounts = TCart["content"]["discounts"];

export type TBeamCartLocalStorage = {
  cartId: string;
  beamCartId?: string;
  subtotal: number;
  itemCount: number;
  currencyCode: string;
} & TCart;

export const BEAM_CART_COOKIE_NAME = "beam_cart";
